
import styles from './ua.module.scss'

export default function StackedPanel(props) {
  
  return <div className={(props.raised ? styles.raised : styles.container) + ' ' + props.className + ' ' + styles[props.theme] } style={ props.style || {} }>
    { props.children }
  </div>
  
}